import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  xblockIframeTitle: {
    id: 'course-authoring.course-unit.xblock.iframe.title',
    defaultMessage: 'Course unit iframe',
    description: 'Title for the xblock iframe',
  },
  xblockIframeLabel: {
    id: 'course-authoring.course-unit.xblock.iframe.label',
    defaultMessage: '{xblockCount} xBlocks inside the frame',
    description: 'Accessible label for the xblock iframe',
  },
});

export default messages;
